import { Component } from '@angular/core';

@Component({
  selector: 'app-pagenotfound',
  styleUrls: ['./pagenotfound.component.scss'],
  templateUrl: './pagenotfound.component.html'
})
export class PageNotFoundComponent {
}